import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import Header from '../PrivateCompanyBlock/Header';
import ProviderManager from '../../../provider/providerManager';
import {getContactCompanyList, setAvailablePortals, setIsShowPopup} from './portalSlice';
import selfCareActions from './selfCareActions';
import './Portal.scss';
import images from './images/images';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import {isBrowser, isMobile, isMobileOnly} from 'react-device-detect';
import ActionIsNotAllowedPopupContent from './ActionIsNotAllowedPopupContent';
import PopUp from '../../Shared/Popup/PopUp';

function Portal(props) {
  let selectHetPay = props.selectedHetPay || '';
  const availablePortals = props.portals.filter((p) => p !== 'Ciber') || [];
  const afterServerResponse = props.canRenderPortals;
  const businessInternetLink = props.iContent.urlBuissness.value;
  const monitorLink = props.iContent.urlNitur.value;

  const updatePaymentUrl = props.iContent.updatePaymentMethodUrl.value;
  const watchInvoicesUrl = props.iContent.watchInvoicesUrl.value;
  const debtPaymentUrl = props.iContent.debtPaymentUrl.value;
  const watchAbroadIndividualUrl = props.iContent.watchAbroadIndividualUrl.value;
  const clientInformationUrl = props.iContent?.clientInformationUrl?.value;
  const dataUsageUrl = props.iContent?.dataUsageUrl?.value;
  const simChangeUrl = props.iContent?.simChangeUrl?.value;
  const imeiDeviceRepairUrl = props.iContent?.imeiDeviceRepairUrl?.value;
  const ccrReportUrl = props.iContent?.ccrReportUrl?.value;
  const businessReportsUrl = props.iContent?.businessReportsUrl?.value;
  const qrRetriveUrl = props.iContent?.qrRetriveUrl?.value;
  const suspendAccountUrl = props.iContent?.suspendAccountUrl?.value;
  const uploadUsersListUrl = props.iContent?.uploadUsersListUrl?.value;
  const transferBusinessAccountUrl = props.iContent?.transferBusinessAccountUrl?.value;
  const ownershipTransferUrl = props.iContent?.ownerShipTransferUrl?.value;
  const businessWorkOrderSystemUrl = props.iContent?.businessWorkOrderSystemUrl?.value;
  const dwhSystemUrl = props.iContent?.dwhSystemUrl?.value;
  const links = {
    watchInvoicesUrl: watchInvoicesUrl,
    updatePaymentUrl: updatePaymentUrl,
    debtPaymentUrl: debtPaymentUrl,
    watchAbroadIndividualUrl: watchAbroadIndividualUrl,
    clientInformationUrl: clientInformationUrl,
    dataUsageUrl: dataUsageUrl,
    simChangeUrl: simChangeUrl,
    businessReportsUrl: businessReportsUrl,
    dwhSystemUrl: dwhSystemUrl,
    qrRetriveUrl: qrRetriveUrl,
  };
  const selfCareActionProps = {
    context: props.context,
    selfCareActionsList: props.iContent.selfCareActions.expandedValue,
    allowedScActions: props.allowedScActions,
    allowedSuspendAction: props.allowedSuspendAction,
    allowedCellular: props.allowedCellular,
    allowedBusinessReports: props.allowedBusinessReports,
    allowedUploadOrgUsersList: props.allowedUploadOrgUsersList,
    isServiceManager: getIfServiceManager(),
    suspendAccountUrl,
    watchInvoicesUrl,
    updatePaymentUrl,
    debtPaymentUrl,
    watchAbroadIndividualUrl,
    clientInformationUrl,
    dataUsageUrl,
    simChangeUrl,
    imeiDeviceRepairUrl,
    ccrReportUrl,
    uploadUsersListUrl,
    businessReportsUrl: businessReportsUrl,
    transferBusinessAccountUrl,
    qrRetriveUrl,
    ownershipTransferUrl,
    businessWorkOrderSystemUrl,
    dwhSystemUrl,
    isRent: props.isRent,
    setIsShowPopup: (flag) => props.setIsShowPopup(flag),
  };

  useEffect(() => {
    if (availablePortals.length != 0) {
      gaEvent(
        gaParams.BUSINESS_PORTAL_REPORT_PORTAL_AMOUNT.category,
        gaParams.BUSINESS_PORTAL_REPORT_PORTAL_AMOUNT.eventType,
        availablePortals.length,
      );
    }
  }, [availablePortals, props.isFullAuthenticated, props.HetPayList]);

  useEffect(() => {
    for (let index = 0; index < props.HetPayList.length; index++) {
      if (selectHetPay && selectHetPay == props.HetPayList[index].idNumber) {
        gaEvent(
          gaParams.BUSINESS_PORTAL_RENDER_AFTER_CHOICE.category,
          gaParams.BUSINESS_PORTAL_RENDER_AFTER_CHOICE.eventType,
          gaParams.BUSINESS_PORTAL_RENDER_AFTER_CHOICE.eventParams,
        );
        break;
      }
    }
  }, [selectHetPay, props.showScActions]);

  useEffect(() => {
    for (let index = 0; index < availablePortals.length; index++) {
      gaEvent(
        gaParams.BUSINESS_PORTAL_RENDER_PORTAL.category,
        gaParams.BUSINESS_PORTAL_RENDER_PORTAL.eventType,
        availablePortals[index].toString(),
      );
    }
  }, [availablePortals]);

  function goTo(goTo, portalName) {
    ReportGA(portalName);
    window.location.assign(goTo);
  }

  function ReportGA(portalName) {
    gaEvent(gaParams.BUSINESS_PORTAL_CLICK_ON_PORTAL.category, gaParams.BUSINESS_PORTAL_CLICK_ON_PORTAL.eventType, portalName);
  }

  function getIfServiceManager() {
    if (props.roles?.includes('CREDENTIALS_SERVICEMANAGER')) {
      return true;
    }
    return false;
  }

  function displayError() {
    if (selectHetPay != '') {
      return (
        <div className='error-container'>
          <Image className='error-pic' alt='no-portals' src={images.error} />
          <div className='error-msg'>
            <strong>אנחנו צריכים הרשאה מתאימה כדי להציג את הנתונים</strong>
            <br />
            בצוות השירות האישי או במוקד העסקי 234* ישמחו לעזור לך בזה
          </div>
        </div>
      );
    } else {
      return isBrowser ? <div style={{height: '200px', width: '100%'}}></div> : <div style={{height: '100px', width: '100%'}}></div>;
    }
  }
  function closeModal() {
    props.setIsShowPopup(false);
  }

  function render() {
    if (selectHetPay != '' && afterServerResponse === true) {
      if (availablePortals.length == 0 && props.showScActions === true) {
        return selfCareActions(selfCareActionProps);
      }
      if (availablePortals.length == 0) {
        return displayError();
      } else {
        return (
          <>
            <Row className='header-row'>
              {isMobile ? null : (
                <h4 className='header'>
                  הפורטלים <strong>שלך</strong>
                </h4>
              )}
            </Row>
            {isMobile ? null : (
              <Row className='portals-row'>
                {availablePortals.includes('BusinessInternet') && (
                  <Container className='portal-choice-container'>
                    <Row onClick={() => goTo(businessInternetLink, 'עסקי באינטרנט')} className='portal-row-container'>
                      <div className='colored-border'></div>
                      <span className='txt'>עסקי באינטרנט</span>
                      <div className='arrow'>
                        <Image alt='arrow' src={images.arrow} />
                      </div>
                    </Row>
                  </Container>
                )}
                {availablePortals.includes('Monitor') && (
                  <Container className='portal-choice-container'>
                    <Row onClick={() => goTo(monitorLink, 'ניטור')} className='portal-row-container'>
                      <div className='colored-border'></div>
                      <span className='txt'>פורטל ניטור</span>
                      <div className='arrow'>
                        <Image alt='arrow' src={images.arrow} />
                      </div>
                    </Row>
                  </Container>
                )}
              </Row>
            )}
            {props.showScActions ? selfCareActions(selfCareActionProps) : null}
          </>
        );
      }
    } else {
      return null;
    }
  }

  return (
    <Container className='portal-root-container'>
      {render()}
      <PopUp
        className={`selfcare-action-not-allowed-popup ${isMobileOnly ? 'isMobile' : ''}`}
        showPopUp={props.isShowPopup}
        onClose={() => closeModal()}>
        <ActionIsNotAllowedPopupContent title='רק רגע אחד...' description={`מצטערים! אין לך הרשאה לבצע פעולה עבור חברה זו`} />
      </PopUp>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  HetPayList: state.portalsBlock.privateCompanyList,
  portals: state.portalsBlock.portals,
  allowedScActions: state.portalsBlock.allowedScActions,
  allowedSuspendAction: state.portalsBlock.allowedSuspendAction,
  allowedCellular: state.portalsBlock.allowedCellular,
  allowedBusinessReports: state.portalsBlock.allowedBusinessReports,
  allowedUploadOrgUsersList: state.portalsBlock.allowedUploadOrgUsersList,
  showScActions: state.portalsBlock.showScActions,
  isShowPopup: state.portalsBlock.isShowPopup,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  isRent: state.portalsBlock.isRent,
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  canRenderPortals: state.portalsBlock.canRenderPortals,
  roles: state.authentication.loginData.userDetails.RoleList,
});

const mapDispatchToProps = {
  getContactCompanyList,
  setAvailablePortals,
  setIsShowPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(Portal);
